import Header from 'parts/Header';
import Footer from 'parts/Footer';
import About from 'parts/About';
import imageAbout from 'assets/images/hero-about.jpg'

function OurProfilePage(props) {
    document.title = "Green Hill Resort | About";
    window.scrollTo(0, 0);

    return (
        <>
            <Header {...props} />
            <section
            style={{
                background: `url(${imageAbout}) no-repeat center center / cover`,
                height: window.innerWidth <= 768 ? "55vh" : "100vh",
                backgroundPosition: window.innerWidth <= 768 ? "center top" : "center center",
                backgroundSize: "cover",
                marginTop: window.innerWidth <= 768 ? "-100px" : "-140px",
            }}
            ></section>
            <About />
            <Footer />
        </>
    );
}

export default OurProfilePage;